import { Box, Link, List, ListItem, SectionMessage, Text, xcss } from '@forge/react';
import React from 'react';
export function ConflictCheckBox(props) {
    const { selectedLabel, hasConflict, conflictingIssues } = props;
    return (React.createElement(Box, { xcss: xcss({ minHeight: '50px' }) },
        hasConflict && (React.createElement(SectionMessage, { appearance: 'error', title: '' },
            React.createElement(Text, null,
                selectedLabel,
                " is unavailable due to conflicts."),
            conflictingIssues.length > 0 && (React.createElement(List, { type: 'unordered' }, conflictingIssues.map((issue) => (React.createElement(ListItem, { key: issue.key },
                React.createElement(Text, null,
                    React.createElement(Link, { openNewTab: true, href: `/browse/${issue.key}` }, issue.key),
                    ' ',
                    issue.fields.summary)))))))),
        !hasConflict && (React.createElement(SectionMessage, { appearance: 'success', title: '' },
            React.createElement(Text, null,
                selectedLabel,
                " is available.")))));
}
